import * as Types from "../../../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type DeleteDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
}>;

export type DeleteDraftMutation = {
  deleteDraft: { __typename: "DraftDeletedOutput"; deletedCount: number };
};

export type ToggleArchiveDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
}>;

export type ToggleArchiveDraftMutation = {
  toggleDraftArchive: { __typename: "MergedDraft"; id: string };
};

export type ToggleArchiveCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type ToggleArchiveCollectionMutation = {
  toggleArchive: { __typename: "MergedCollection"; id: string };
};

export type DuplicateCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  data: Types.DuplicateCollectionInput;
}>;

export type DuplicateCollectionMutation = {
  duplicateCollection: {
    __typename: "MergedDraft";
    collectionType: Types._CollectionType;
    createdAt: string;
    id: string;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        allowedHashes: Array<string> | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        } | null;
      } | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      chainId: number | null;
      symbol: string | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewMediaUrls: Array<string> | null;
      } | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      saleDateTo: string | null;
      saleDateFrom: string | null;
      price: string | null;
      currency: string | null;
      priceType: Types.PriceType | null;
      type: Types.TokenDistributionType;
    } | null;
  };
};

export type DuplicateDraftMutationVariables = Types.Exact<{
  draftId: Types.Scalars["String"];
  data: Types.DuplicateCollectionInput;
}>;

export type DuplicateDraftMutation = {
  duplicateCollectionDraft: {
    __typename: "MergedDraft";
    collectionType: Types._CollectionType;
    createdAt: string;
    id: string;
    collectionDraft: {
      __typename: "CollectionDetailsDraft";
      name: string | null;
      generativeDetails: {
        __typename: "GenerativeDetailsDraft";
        allowedHashes: Array<string> | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        } | null;
      } | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
      } | null;
    } | null;
    contractDraft: {
      __typename: "ContractDraft";
      chainId: number | null;
      symbol: string | null;
      usingOpenseaBlocklist: boolean | null;
      collectionLogoImage: string | null;
    } | null;
    metadata: {
      __typename: "CollectionMetadata";
      mediaUrl: string | null;
      seriesDetails: {
        __typename: "SeriesDetailsDraft";
        coverImage: Array<number> | null;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewImages: Array<number> | null;
        mintPreviewMediaUrls: Array<string> | null;
      } | null;
    } | null;
    distributionDraft: {
      __typename: "DistributionDraft";
      saleDateTo: string | null;
      saleDateFrom: string | null;
      price: string | null;
      currency: string | null;
      priceType: Types.PriceType | null;
      type: Types.TokenDistributionType;
    } | null;
  };
};

export const DeleteDraftDocument = gql`
  mutation DeleteDraft($draftId: String!) {
    deleteDraft(draftId: $draftId) {
      deletedCount
    }
  }
`;
export type DeleteDraftMutationFn = Apollo.MutationFunction<
  DeleteDraftMutation,
  DeleteDraftMutationVariables
>;

/**
 * __useDeleteDraftMutation__
 *
 * To run a mutation, you first call `useDeleteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftMutation, { data, loading, error }] = useDeleteDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useDeleteDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDraftMutation,
    DeleteDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDraftMutation, DeleteDraftMutationVariables>(
    DeleteDraftDocument,
    options
  );
}
export type DeleteDraftMutationHookResult = ReturnType<
  typeof useDeleteDraftMutation
>;
export type DeleteDraftMutationResult =
  Apollo.MutationResult<DeleteDraftMutation>;
export type DeleteDraftMutationOptions = Apollo.BaseMutationOptions<
  DeleteDraftMutation,
  DeleteDraftMutationVariables
>;
export const ToggleArchiveDraftDocument = gql`
  mutation ToggleArchiveDraft($draftId: String!) {
    toggleDraftArchive(draftId: $draftId) {
      id
    }
  }
`;
export type ToggleArchiveDraftMutationFn = Apollo.MutationFunction<
  ToggleArchiveDraftMutation,
  ToggleArchiveDraftMutationVariables
>;

/**
 * __useToggleArchiveDraftMutation__
 *
 * To run a mutation, you first call `useToggleArchiveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchiveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchiveDraftMutation, { data, loading, error }] = useToggleArchiveDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useToggleArchiveDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleArchiveDraftMutation,
    ToggleArchiveDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleArchiveDraftMutation,
    ToggleArchiveDraftMutationVariables
  >(ToggleArchiveDraftDocument, options);
}
export type ToggleArchiveDraftMutationHookResult = ReturnType<
  typeof useToggleArchiveDraftMutation
>;
export type ToggleArchiveDraftMutationResult =
  Apollo.MutationResult<ToggleArchiveDraftMutation>;
export type ToggleArchiveDraftMutationOptions = Apollo.BaseMutationOptions<
  ToggleArchiveDraftMutation,
  ToggleArchiveDraftMutationVariables
>;
export const ToggleArchiveCollectionDocument = gql`
  mutation ToggleArchiveCollection($collectionId: String!) {
    toggleArchive(collectionId: $collectionId) {
      id
    }
  }
`;
export type ToggleArchiveCollectionMutationFn = Apollo.MutationFunction<
  ToggleArchiveCollectionMutation,
  ToggleArchiveCollectionMutationVariables
>;

/**
 * __useToggleArchiveCollectionMutation__
 *
 * To run a mutation, you first call `useToggleArchiveCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchiveCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchiveCollectionMutation, { data, loading, error }] = useToggleArchiveCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useToggleArchiveCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleArchiveCollectionMutation,
    ToggleArchiveCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleArchiveCollectionMutation,
    ToggleArchiveCollectionMutationVariables
  >(ToggleArchiveCollectionDocument, options);
}
export type ToggleArchiveCollectionMutationHookResult = ReturnType<
  typeof useToggleArchiveCollectionMutation
>;
export type ToggleArchiveCollectionMutationResult =
  Apollo.MutationResult<ToggleArchiveCollectionMutation>;
export type ToggleArchiveCollectionMutationOptions = Apollo.BaseMutationOptions<
  ToggleArchiveCollectionMutation,
  ToggleArchiveCollectionMutationVariables
>;
export const DuplicateCollectionDocument = gql`
  mutation DuplicateCollection(
    $collectionId: String!
    $data: DuplicateCollectionInput!
  ) {
    duplicateCollection(collectionId: $collectionId, data: $data) {
      collectionType
      createdAt
      id
      collectionDraft {
        name
        generativeDetails {
          allowedHashes
          captureSettings {
            trigger
            delay
            selector
            viewPort {
              height
              width
              __typename
            }
            __typename
          }
          __typename
        }
        seriesDetails {
          coverImage
          mintPreviewImages
          mintPreviewImageUrls
          mintPreviewMediaUrls
          __typename
        }
        __typename
      }
      contractDraft {
        chainId
        symbol
        usingOpenseaBlocklist
        collectionLogoImage
        __typename
      }
      metadata {
        mediaUrl
        seriesDetails {
          coverImage
          mintPreviewImageUrls
          mintPreviewImages
          mintPreviewMediaUrls
          __typename
        }
        __typename
      }
      distributionDraft {
        saleDateTo
        saleDateFrom
        price
        currency
        priceType
        type
        __typename
      }
      __typename
    }
  }
`;
export type DuplicateCollectionMutationFn = Apollo.MutationFunction<
  DuplicateCollectionMutation,
  DuplicateCollectionMutationVariables
>;

/**
 * __useDuplicateCollectionMutation__
 *
 * To run a mutation, you first call `useDuplicateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCollectionMutation, { data, loading, error }] = useDuplicateCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateCollectionMutation,
    DuplicateCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateCollectionMutation,
    DuplicateCollectionMutationVariables
  >(DuplicateCollectionDocument, options);
}
export type DuplicateCollectionMutationHookResult = ReturnType<
  typeof useDuplicateCollectionMutation
>;
export type DuplicateCollectionMutationResult =
  Apollo.MutationResult<DuplicateCollectionMutation>;
export type DuplicateCollectionMutationOptions = Apollo.BaseMutationOptions<
  DuplicateCollectionMutation,
  DuplicateCollectionMutationVariables
>;
export const DuplicateDraftDocument = gql`
  mutation DuplicateDraft($draftId: String!, $data: DuplicateCollectionInput!) {
    duplicateCollectionDraft(draftId: $draftId, data: $data) {
      collectionType
      createdAt
      id
      collectionDraft {
        name
        generativeDetails {
          allowedHashes
          captureSettings {
            trigger
            delay
            selector
            viewPort {
              height
              width
              __typename
            }
            __typename
          }
          __typename
        }
        seriesDetails {
          coverImage
          mintPreviewImages
          mintPreviewImageUrls
          mintPreviewMediaUrls
          __typename
        }
        __typename
      }
      contractDraft {
        chainId
        symbol
        usingOpenseaBlocklist
        collectionLogoImage
        __typename
      }
      metadata {
        mediaUrl
        seriesDetails {
          coverImage
          mintPreviewImageUrls
          mintPreviewImages
          mintPreviewMediaUrls
          __typename
        }
        __typename
      }
      distributionDraft {
        saleDateTo
        saleDateFrom
        price
        currency
        priceType
        type
        __typename
      }
      __typename
    }
  }
`;
export type DuplicateDraftMutationFn = Apollo.MutationFunction<
  DuplicateDraftMutation,
  DuplicateDraftMutationVariables
>;

/**
 * __useDuplicateDraftMutation__
 *
 * To run a mutation, you first call `useDuplicateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDraftMutation, { data, loading, error }] = useDuplicateDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateDraftMutation,
    DuplicateDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateDraftMutation,
    DuplicateDraftMutationVariables
  >(DuplicateDraftDocument, options);
}
export type DuplicateDraftMutationHookResult = ReturnType<
  typeof useDuplicateDraftMutation
>;
export type DuplicateDraftMutationResult =
  Apollo.MutationResult<DuplicateDraftMutation>;
export type DuplicateDraftMutationOptions = Apollo.BaseMutationOptions<
  DuplicateDraftMutation,
  DuplicateDraftMutationVariables
>;
